<template>
  <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="等级名称" required>
      <el-input v-model="form.title" placeholder="请输入等级名称" />
    </el-form-item>
    <el-form-item label="收益加成(%)">
      <el-input v-model="form.extra" placeholder="请输入收益加成百分比" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="团队投资要求">
      <el-input v-model="form.team_invest" placeholder="请输入团队投资要求金额" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="周奖励">
      <el-input v-model="form.weekly_rewards" placeholder="请输入周奖励金额" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="月俸禄">
      <el-input v-model="form.monthly_salary" placeholder="请输入月俸禄金额" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="单笔认购">
      <el-input v-model="form.single_buy" placeholder="请输入单笔认购金额" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="一级返利(%)">
      <el-input v-model="form.lv1_invite" placeholder="请输入一级返利百分比" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="二级返利(%)">
      <el-input v-model="form.lv2_invite" placeholder="请输入二级返利百分比" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="一级认购奖励(%)">
      <el-input v-model="form.lv1_buy" placeholder="请输入一级认购奖励百分比" type="number" step="0.01" />
    </el-form-item>
    <el-form-item label="二级认购奖励(%)">
      <el-input v-model="form.lv2_buy" placeholder="请输入二级认购奖励百分比" type="number" step="0.01" />
    </el-form-item>
  </el-form>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'

const form = ref({
  title: "",
  extra: "",
  team_invest: "",
  lv1_invite: "",
  lv2_invite: "",
  lv1_buy: "",
  lv2_buy: "",
  weekly_rewards: "",
  monthly_salary: "",
  single_buy: "",
})
const props = defineProps(['item'])

onMounted(() => {
  nextTick(() => {
    form.value = Object.assign(form.value, props.item)
  })
})

defineExpose({ form })

</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}

/deep/ .el-radio-group {
  width: 220px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>

